
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/applications/landing",
      function () {
        return require("private-next-pages/applications/landing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/applications/landing"])
      });
    }
  